import Branding from "./Branding";

export default Branding;
